export default __webpack_public_path__ + "static/media/github-24-px.67158c1c.svg";